import React, { useState } from "react";
import styles from './Leftnav.module.scss'
import {
  PATH_HOME,
  PATH_IDO_ADMINISTRATION, PATH_PROJECT_INTEREST,
  PATH_RAFFLE_ADMINISTRATION,
  PATH_VAULT_ADMINISTRATION,
  PATH_TUTORIAL_ADMINISTRATION,
  PATH_USER_ADMINISTRATION, PATH_RANKING_ADMINISTRATION, PATH_MISSION_ADMINISTRATION
} from "../../App";
import { ReactComponent as StarLaunchLogo } from "../../images/svg/logo.svg";
import {useNavigate} from "react-router-dom";

function Leftnav() {
  const navigate = useNavigate();

  return (
    <div className="sidebar" onClick={e => e.stopPropagation()}>
      <nav
          id="sidebarMenu"
          className={styles.navigationBar}
      >
        <div className="logoContainer" onClick={() => navigate(PATH_HOME)}>
          <StarLaunchLogo className="logo"/>
          <span className="logoText">StarLaunch</span>
        </div>
        <div className={styles.navigationItem} onClick={() => navigate(PATH_HOME)}>
          HOME
        </div>
        <div className={styles.navigationItem} onClick={() => navigate(PATH_IDO_ADMINISTRATION)}>
          IDO ADMINISTRATION
        </div>
        <div className={styles.navigationItem} onClick={() => navigate(PATH_VAULT_ADMINISTRATION)}>
          VAULT ADMINISTRATION
        </div>
        <div className={styles.navigationItem} onClick={() => navigate(PATH_USER_ADMINISTRATION)}>
          USER ADMINISTRATION
        </div>
        <div className={styles.navigationItem} onClick={() => navigate(PATH_PROJECT_INTEREST)}>
          PROJECT INTEREST
        </div>
        <div className={styles.navigationItem} onClick={() => navigate(PATH_RAFFLE_ADMINISTRATION)}>
          RAFFLE ADMINISTRATION
        </div>
        <div className={styles.navigationItem} onClick={() => navigate(PATH_TUTORIAL_ADMINISTRATION)}>
          TUTORIAL ADMINISTRATION
        </div>
        <div className={styles.navigationItem} onClick={() => navigate(PATH_RANKING_ADMINISTRATION)}>
          RANKING ADMINISTRATION
        </div>
        <div className={styles.navigationItem} onClick={() => navigate(PATH_MISSION_ADMINISTRATION)}>
          MISSION ADMINISTRATION
        </div>
      </nav>
    </div>
  );
}

export default Leftnav;
